import React, { useState } from 'react';
import './App.css';

function App() {
  const [isGameStarted, setIsGameStarted] = useState(false);
  const [numPlayers, setNumPlayers] = useState(2);
  const [playerNames, setPlayerNames] = useState(Array(4).fill('').map((_, i) => `Jugador ${i + 1}`));

  const [players, setPlayers] = useState([]);
  const [gameType, setGameType] = useState(501);
  const [currentPlayerIndex, setCurrentPlayerIndex] = useState(0);
  const [currentDart, setCurrentDart] = useState(1);
  const [turnScores, setTurnScores] = useState([]);

  const [selectedSegment, setSelectedSegment] = useState(null);
  const [selectedMultiplier, setSelectedMultiplier] = useState(1);

  const handlePlayerNameChange = (index, name) => {
    const newNames = [...playerNames];
    newNames[index] = name;
    setPlayerNames(newNames);
  };

  const startGame = () => {
    const activePlayers = playerNames.slice(0, numPlayers).map((name, index) => ({
      id: index + 1,
      name: name || `Jugador ${index + 1}`,
      score: gameType,
      history: []
    }));
    setPlayers(activePlayers);
    setIsGameStarted(true);
    setCurrentPlayerIndex(0);
    setCurrentDart(1);
    setTurnScores([]);
  };

  const addScore = (segment, multiplier) => {
    const hitScore = segment * multiplier;
    
    setPlayers(prevPlayers => {
      const newPlayers = [...prevPlayers];
      const currentPlayer = { ...newPlayers[currentPlayerIndex] };

      let newScore = currentPlayer.score - hitScore;

      if (newScore < 0 || newScore === 1) {
        alert("BUST! Et mantens amb la puntuació anterior.");
        // End turn immediately on bust
        finishTurn(newPlayers);
        return newPlayers;
      } else if (newScore === 0) {
        alert(`FELICITATS! ${currentPlayer.name} ha guanyat!`);
        currentPlayer.score = 0;
        newPlayers[currentPlayerIndex] = currentPlayer;
        return newPlayers;
      } else {
        currentPlayer.score = newScore;
        newPlayers[currentPlayerIndex] = currentPlayer;
        
        // Update turn history
        const newTurnScores = [...turnScores, hitScore];
        setTurnScores(newTurnScores);

        if (currentDart === 3) {
          finishTurn(newPlayers);
        } else {
          setCurrentDart(currentDart + 1);
        }
        return newPlayers;
      }
    });

    setSelectedSegment(null);
    setSelectedMultiplier(1);
  };

  const finishTurn = (currentPlayers) => {
    setCurrentDart(1);
    setTurnScores([]);
    setCurrentPlayerIndex((currentPlayerIndex + 1) % currentPlayers.length);
  };

  if (!isGameStarted) {
    return (
      <div className="setup-container">
        <h1>Darts Counter v2</h1>
        <div className="setup-card">
          <label>Jugadors:</label>
          <div className="player-selector">
            {[2, 3, 4].map(n => (
              <button key={n} className={numPlayers === n ? 'active' : ''} onClick={() => setNumPlayers(n)}>{n}</button>
            ))}
          </div>
          <div className="names-input">
            {[...Array(numPlayers)].map((_, i) => (
              <input 
                key={i}
                type="text" 
                value={playerNames[i]} 
                onChange={(e) => handlePlayerNameChange(i, e.target.value)}
                placeholder={`Nom Jugador ${i+1}`}
              />
            ))}
          </div>
          <button className="start-btn" onClick={startGame}>COMENÇAR 501</button>
        </div>
      </div>
    );
  }

  const currentPlayer = players[currentPlayerIndex];

  return (
    <div className="game-container">
      <div className="scoreboard">
        {players.map((p, i) => (
          <div key={p.id} className={`score-card ${i === currentPlayerIndex ? 'active' : ''}`}>
            <div className="player-name">{p.name}</div>
            <div className="player-score">{p.score}</div>
          </div>
        ))}
      </div>

      <div className="turn-info">
        <h3>Torn de: {currentPlayer.name}</h3>
        <div className="darts-indicator">
          {[1, 2, 3].map(d => (
            <div key={d} className={`dart-dot ${d <= currentDart ? 'active' : ''} ${d < currentDart ? 'thrown' : ''}`}></div>
          ))}
        </div>
        <div className="current-turn-total">
           Dards tirats: {turnScores.join(' + ') || '0'}
        </div>
      </div>

      <div className="input-area">
        <div className="multiplier-bar">
          <button className={selectedMultiplier === 1 ? 'active' : ''} onClick={() => setSelectedMultiplier(1)}>SINGLE</button>
          <button className={selectedMultiplier === 2 ? 'active' : ''} onClick={() => setSelectedMultiplier(2)}>DOUBLE</button>
          <button className={selectedMultiplier === 3 ? 'active' : ''} onClick={() => setSelectedMultiplier(3)}>TRIPLE</button>
        </div>
        
        <div className="grid-numbers">
          {[...Array(20)].map((_, i) => (
            <button key={i+1} onClick={() => addScore(i+1, selectedMultiplier)}>{i+1}</button>
          ))}
          <button className="bull" onClick={() => addScore(25, 1)}>BULL (25)</button>
          <button className="bullseye" onClick={() => addScore(25, 2)}>D-BULL (50)</button>
          <button className="miss" onClick={() => addScore(0, 1)}>MISS (0)</button>
        </div>
      </div>
    </div>
  );
}

export default App;
